import type { TFunction } from "i18next";
import { DateTime } from "luxon";

import type { ModerationState } from "@/redux/discussions/types";
import {
  MODERATION_STATES,
  UNDER_REVIEW_STATES,
} from "@/domains/moderation/constants";

export const formatWaitingAge = (
  t: TFunction,
  createdAt: string,
  now: DateTime = DateTime.now(),
) => {
  const { days, hours, minutes } = now
    .diff(DateTime.fromISO(createdAt), ["days", "hours", "minutes"])
    .toObject();
  if (days && days >= 1) {
    return t("moderation.age.days", { count: Math.floor(days) });
  }
  if (hours && hours >= 1) {
    return t("moderation.age.hours", { count: Math.floor(hours) });
  }
  return t("moderation.age.minutes", {
    count: Math.max(Math.floor(minutes ?? 0), 1),
  });
};

export const getWaitingTitleKey = (postCount: number, commentCount: number) => {
  if (postCount > 0 && commentCount > 0) {
    return "moderation.alert.titleMixed";
  }
  return postCount > 0
    ? "moderation.alert.titlePosts"
    : "moderation.alert.titleComments";
};

export const isHiddenFromMembers = (state: ModerationState | undefined) =>
  !!state &&
  (state === MODERATION_STATES.REJECTED || UNDER_REVIEW_STATES.includes(state));
